import {
    Sprite,
    Texture,
} from 'pixi.js';
import { Button, TextSettings } from './Button';
import { StyledBitmapText } from './StyledBitmapText';

export class ActiveButton extends Button
{
    protected activeSprite: Sprite;
    protected activeText: StyledBitmapText;
    private _active:boolean;

    constructor(normalTexture?: Texture, normalText?: TextSettings, activeTexture?: Texture, activeText?: TextSettings)
    {
        super(normalTexture, normalText);
        this._active = false;
        if (activeTexture)
        {
            this.activeSprite = new Sprite(activeTexture);
            this.activeSprite.anchor.set(0.5);
            this.addChild(this.activeSprite);
            this.activeSprite.visible = false;
        }
        if (activeText && activeText.style)
        {
            this.activeText = new StyledBitmapText(activeText.content, activeText.style);
            this.activeText.updateText();
            this.activeText.anchor.set(0.5, 0.6);
            if (activeText.offset)
            {
                this.activeText.position.set(activeText.offset.x, activeText.offset.y);
            }
            this.addChild(this.activeText);
            this.activeText.visible = false;
        }
    }

    protected getSize()
    {
        const target = this.sprite || this.activeSprite || this.text || this.activeText;
        return {width: target.width, height: target.height};
    }

    public set active(active: boolean)
    {
        this._active = active;
        if (this.activeSprite)
        {
            this.activeSprite.visible = active;
        }
        if (this.activeText && this.activeText !== this.text)
        {
            this.activeText.visible = active;
        }
        if (this.sprite)
        {
            this.sprite.visible = !active;
        }
        if (this.text && this.activeText !== this.text)
        {
            this.text.visible = !active;
        }
    }

    public get active():boolean
    {
        return this._active;
    }
}